<div class="modalContainer">
    <div class="modal-header">
        <div class="modal-title">
            <img alt="success_thumb" style="height: 6rem;" src="../../../assets/images/rbi-compliance/reject_confirmation.svg" />
            <div class="mt-4">Are you Sure</div>
        </div>
        <div class="modal-sub-title">Do you want to reject the loan settlement offer</div>
    </div>

    <div class="modal-footer">
        <button (click)="decline()" type="button" mat-stroked-button class="primary no-text-transform"
            [mat-dialog-close]="true" cdkFocusInitial>Back</button>

        <button type="button" mat-flat-button class="primary no-text-transform continue-button"
            [mat-dialog-close]="true" cdkFocusInitial>Reject</button>
    </div>
</div>